import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor, FormBuilder, FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors
} from "@angular/forms";
import {map, startWith} from "rxjs/operators";
import {SensorEventActuator} from "../../ParseClass/SensorEvent.Parse";
import {Observable, Subscription} from "rxjs";
import {typeFormValue} from "../../configurationProperty/configurationPropertyUtils";
import {arrayIsSet, stringIsSet} from "../../providers/service/global-variables.service";
import {IconService} from "../../providers/service/icon.service";

export class RangeMenuChipsWithMultiSelectType {
    traduction: string | undefined
    noTraduction: string | undefined
    objectId: string
    minAccepeted: number | undefined
    maxAccepeted: number | undefined
    min: number | undefined
    max: number | undefined


    constructor(objectId: string | undefined) {
        if (stringIsSet(objectId)) {
            this.objectId = objectId
        } else {
            this.objectId = new Date().getTime().toString(32)
        }
    }

    get traductionNoTraduction() {
        return {traduction: this.traduction, notTraduction: this.noTraduction}
    }


}

export class MenuChipsWithMultiSelectType {
    typeForm = typeFormValue.CHECKBOX;
    multiple: boolean = false
    traduction: string | undefined
    noTraduction: string | undefined
    objectId: string
    keyReferement:string|undefined


    constructor(objectId: string | undefined) {
        if (stringIsSet(objectId)) {
            this.objectId = objectId
        } else {
            this.objectId = new Date().getTime().toString(32)
        }
    }

    get traductionNoTraduction() {
        return {traduction: this.traduction, notTraduction: this.noTraduction}
    }


}

export class ChipsWithMultiSelectType {
    objectId: string
    traduction: string | undefined
    noTraduction: string | undefined
    readonly selectablePossibleValues: Map<string, MenuChipsWithMultiSelectType> | undefined
    readonly rangesPossibleValues: Map<string, RangeMenuChipsWithMultiSelectType> | undefined
    private selectedIds = new Set<string>()
    private rangesValue = new Map<string, RangeMenuChipsWithMultiSelectType>

    constructor(objectId: string | undefined, selectablePossibleValues: MenuChipsWithMultiSelectType[] | undefined, rangePossibleValues: RangeMenuChipsWithMultiSelectType[] | undefined) {
        if (stringIsSet(objectId)) {
            this.objectId = objectId
        } else {
            this.objectId = new Date().getTime().toString(32)
        }
        if (arrayIsSet(selectablePossibleValues)) {
            this.selectablePossibleValues = new Map<string, MenuChipsWithMultiSelectType>;
            selectablePossibleValues.forEach(value => {
                this.selectablePossibleValues?.set(value.objectId, value)
                this.selectedIds?.add(value.objectId)
            })
        }
        if (arrayIsSet(rangePossibleValues)) {
            this.rangesPossibleValues = new Map<string, RangeMenuChipsWithMultiSelectType>;
            rangePossibleValues.forEach(value => {
                this.rangesPossibleValues?.set(value.objectId, value)
            })
        }
    }

    isEquals(element: ChipsWithMultiSelectType) {
        return this.objectId === element.objectId
    }

    get traductionNoTraduction() {
        return {traduction: this.traduction, notTraduction: this.noTraduction}
    }

    get selected(): MenuChipsWithMultiSelectType[] | undefined {
        if (this.selectedIds.size > 0) {
            const selected: MenuChipsWithMultiSelectType[] = []
            this.selectedIds.forEach(id => {
                selected.push(this.selectablePossibleValues?.get(id)!)
            })
            return selected;
        } else {
            return undefined
        }
    }

    addOrRemove(id: string) {
        if (this.selectedIds?.has(id)) {
            this.selectedIds?.delete(id)
        } else {
            this.selectedIds.add(id)
        }
    }

    addOrRemoveRange(rangePossibleValue: RangeMenuChipsWithMultiSelectType, newValues: {
        minValue: number | undefined, maxValue: number | undefined
    },) {
        rangePossibleValue.min = newValues.minValue
        rangePossibleValue.max = newValues.maxValue
        if (rangePossibleValue.min == null && rangePossibleValue.max == null) {
            this.rangesValue.delete(rangePossibleValue.objectId)
        } else {
            this.rangesValue.set(rangePossibleValue.objectId, rangePossibleValue)
        }
    }

    get currentRangesValues(): RangeMenuChipsWithMultiSelectType[] {
        const values: RangeMenuChipsWithMultiSelectType[] = []
        this.rangesValue.forEach((key: RangeMenuChipsWithMultiSelectType) => {
            values.push(key)
        })
        return values

    }

    isSelected(id: string) {
        return this.selectedIds.has(id)
    }

    openMenu() {
        return (this.selectablePossibleValues && this.selectablePossibleValues.size > 0) || (this.rangesPossibleValues && this.rangesPossibleValues.size > 0)
    }
}

@Component({
    selector: 'app-form-field-chips--with-multi-select',
    templateUrl: './form-field-chips-with-multi-select.component.html',
    styleUrls: ['./form-field-chips-with-multi-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FormFieldChipsWithMultiSelectComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FormFieldChipsWithMultiSelectComponent
        }
    ],
    standalone: false
})
export class FormFieldChipsWithMultiSelectComponent implements OnChanges, ControlValueAccessor {
    @Input() possibleValues: ChipsWithMultiSelectType[] | undefined;
    form: FormGroup<any>
    private subscriptions = new Subscription()
    public lastClick$: Observable<ChipsWithMultiSelectType | undefined>
    public selectedIds$: Observable<string[] | undefined>
    public selected$: Observable<ChipsWithMultiSelectType[] | undefined>

    constructor(fb: FormBuilder,
                private iconService: IconService) {
        iconService.addSvgIcon('menuRound', 'assets/icon/button/menu_round.svg')
        this.form = fb.group({selectedIds: undefined, lastClick: undefined,})
        this.selectedIds$ = this.form.get('selectedIds')!.valueChanges.pipe(
            startWith(undefined),
            map((value) => {
                return this.selectedIds
            })
        )
        this.selected$ = this.selectedIds$.pipe(
            map((ids) => {
                if (arrayIsSet(ids) && arrayIsSet(this.possibleValues)) {
                    return ids.map(id => this.possibleValues!.find(pValue => pValue.objectId == id)!)
                } else {
                    return undefined
                }
            })
        )
        this.lastClick$ = this.form.get('lastClick')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('lastClick')?.value)
        )

    }

    get selectedIds() {
        return this.form.get('selectedIds')!.value
    }

    set selectedIds(value: string[]) {
        this.form.get('selectedIds')!.setValue(value)
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const values$ = this.selected$
        this.subscriptions.add(
            values$.subscribe(onChange)
        );

    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    writeValue(value: ChipsWithMultiSelectType[] | string[]) {
        if (value != null) {
            let select: string[] = [];
            if (value[0] instanceof ChipsWithMultiSelectType) {
                select = value.map((pValue: any) => pValue.objectId)
            } else if (typeof value[0] == "string") {
                select = value as string[]
            }
            this.selectedIds = select
        } else {
            this.form.reset()
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.form.valid) {
            return null
        } else {
            return this.form.errors!;
        }
    }

    addControlErrors(allErrors: any, controlName: string) {
        const errors = {...allErrors};
        const controlErrors = this.form.controls[controlName].errors;
        if (controlErrors) {
            errors[controlName] = controlErrors;
        }
        return errors;
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }


    setLastClick(value: ChipsWithMultiSelectType) {
        this.form.get('lastClick')?.setValue(value);
    }

    isSelectedPredicate(listSelected: ChipsWithMultiSelectType[], element: ChipsWithMultiSelectType) {
        if (arrayIsSet(listSelected)) {
            return listSelected.some(el => el.isEquals(element))
        } else {
            return false
        }
    }

    getColorChips(listSelected: ChipsWithMultiSelectType[], element: ChipsWithMultiSelectType) {
        if (arrayIsSet(listSelected)) {
            const index = listSelected.findIndex(el => el.isEquals(element))
            if (index >= 0) {
                return index % 2 ? 'primary' : 'accent'
            }
        }
        return undefined
    }

    menuClosed() {
        this.form.get('lastClick')?.reset()
    }

    updateValue() {
        const select = arrayIsSet(this.selectedIds) ? [...this.selectedIds] : []
        this.selectedIds = select
    }
}
